<template>
  <div id="app">
	<tabs></tabs>
	<div class="content3">
	<router-view></router-view>
	
	<!-- <el-backtop target=".content3"></el-backtop> -->
	</div>
	<fotter></fotter>
  </div>
</template>

<script>
	import tabs from './components/common/tabs.vue'
	import fotter from './components/common/fotter.vue'
export default{
	components:{
		tabs,
		fotter
	},
		data(){
			return{
			}
		},
		methods:{
			
		}
	}
</script>

<style>
	@import "./assets/css/main.css";
	@import "./assets/css/color-dark.css";  
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: auto;
}
</style>
